import {IElement} from '../incase-domain/elements';
import {IPresentation} from '../incase-domain/presentation';
import {shapeElementTypes} from '../incase-domain/elements/base/ElementTypes';

export const handleLoadedPresentation = (presentation: IPresentation): IPresentation => {
    const handleGameConfig = (presentation: IPresentation): IPresentation => {
        const {gameConfig} = presentation;
        const correctPointsPlus = gameConfig?.correctPointsPlus || 0;
        const wrongPointsMinus = gameConfig?.wrongPointsMinus || 0;
        const gameClock = gameConfig?.gameClock || 0;
        const isGamificationOn = gameConfig?.isGamificationOn;

        return {
            ...presentation,
            gameConfig: {
                correctPointsPlus,
                wrongPointsMinus,
                gameClock,
                isGamificationOn,
            },
        };
    };

    return handleGameConfig(presentation);
};

export function filterAndSortMobileElements(elements: IElement[]): IElement[] {
    return [...elements]
        .filter((e) => e.hideOnMobile !== true)
        .filter((e) => !shapeElementTypes.includes(e.type))
        .sort((a, b) => {
            const orderA = a.mobileOrder ?? Number.MIN_SAFE_INTEGER;
            const orderB = b.mobileOrder ?? Number.MIN_SAFE_INTEGER;
            return orderA - orderB;
        });
}
